import type { ReactElement } from 'react';
// import { Route } from 'react-router-dom';

// Placeholder for user screens - to be created
// import { ProfileScreen, OrdersScreen, WishlistScreen } from '../screens';

export const userRoutes: ReactElement[] = [
  // <Route key="profile" path="/account/profile" element={<ProfileScreen />} />,
  // <Route key="orders" path="/account/orders" element={<OrdersScreen />} />,
  // <Route key="wishlist" path="/account/wishlist" element={<WishlistScreen />} />,
];

